module.exports = __webpack_public_path__ + "img/gao2.9f222346.png";